import { Separator } from '@1trading/react';
import { EnvTag } from '@/components/ui/env-tag';
import { Breadcrumbs } from '@/layouts/default/breadcrumbs';
import { ExchangeStatusIndicator } from '@/layouts/default/exchange-status-indicator';

// No sidebar toggle here — the sidebar's own Collapse/Expand control (SidebarFooter)
// already does that job; having it twice just crowded the one place exchange health
// actually needs to live, visible on every page without scrolling.
const Header = () => {
  return (
    <header className="flex h-14 shrink-0 items-center gap-3 border-b px-4">
      <ExchangeStatusIndicator />
      <Separator className="h-5" orientation="vertical" />
      <Breadcrumbs />
      <div className="ml-auto flex items-center gap-2">
        <EnvTag />
        {/* Auth user summary lands here in Phase 2 */}
      </div>
    </header>
  );
};
Header.displayName = 'Header';

export default Header;
